
import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator';
import api from '@/api';

const productApi = api.product;

@Component({})

export default class ProductPickerRow extends Vue {
  @Prop({}) private merchants!: Array<{
    text: string,
    value: number,
    ignoreIds: number[],
  }>;

  @Prop({ default: true }) private isSingleMode!: boolean;

  @Prop({}) private merchantId!: number;

  @Prop({}) private productId!: string;

  @Prop({}) private quantity!: number;

  @Prop({}) private disabled!: boolean;

  private rowQuantity: number = this.quantity;

  private merchantProducts: Array<{ text: string, value: string }> = [];

  private requiredRule(colName: string) {
    return [(v: number | null) => !!v || `請選擇${colName}欄位`];
  }

  private get products() {
    const merchant = this.merchants.find((m) => m.value === this.merchantId) || { ignoreIds: [] };
    return this.merchantProducts.filter(
      (i: any) => merchant.ignoreIds.findIndex((v) => i.value === v) === -1
        || i.value === this.productId,
    );
  }

  private async mounted() {
    await this.merchantChanged(this.merchantId);
  }

  private async merchantChanged(merchantId: number) {
    if (merchantId === 0) return;
    const queryFilter = {
      merchantId,
      pageNo: 1,
      status: 3,
    };
    const { data: { data: products = [] } } = await productApi.list(queryFilter);
    this.merchantProducts = products.map(
      (v: any) => ({ text: `(${v.sequence})${v.productName}`, value: v.productId }),
    );
    if (merchantId !== this.merchantId) {
      this.change(merchantId, null);
    }
  }

  @Emit('quantity-Changed')
  private quantityChanged(quantity: number) {
    return quantity;
  }

  @Emit('product-changed')
  private change(merchantId: number, productId: string | null) {
    return { merchantId, productId };
  }
}

